import React, { useContext } from "react";
import { contactLinks } from "../constants";
import { ThemeContext } from "../themeProvider";

const Contact = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;
  return (
    <div
      id="contact"
      className={
        darkMode
          ? "bg-gray-100 pt-24 md:h-screen"
          : "bg-gray-700 pt-24 text-white md:h-screen"
      }
    >
      <div className="max-w-7xl mx-auto x-4 sm:px-6 lg:px-8 px-4 ">
        <h2 className="text-5xl font-bold px-4 md:px-0 text-center z-0">
          CONTACT
        </h2>
        <div className="flex justify-between items-center md:items-stretch  flex-col md:flex-row">
          <div className="w-full md:pr-8">
            <form
              action="https://getform.io/f/b332c9a3-b962-49c9-bfd4-46e3e0aa7d2d"
              method="POST"
            >
              <div class="my-6">
                <label
                  for="name"
                  class={
                    darkMode
                      ? "block mb-2 text-lg font-medium text-gray-900"
                      : "block mb-2 text-lg font-medium text-white"
                  }
                >
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Enter your name"
                  required
                />
              </div>
              <div className="mb-4">
                <label
                  for="email"
                  class={
                    darkMode
                      ? "block mb-2 text-lg font-medium text-gray-900"
                      : "block mb-2 text-lg font-medium text-white"
                  }
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Enter your email"
                  required
                />
              </div>
              <div className="mb-4">
                <label
                  for="message"
                  class={
                    darkMode
                      ? "block mb-2 text-lg font-medium text-gray-900"
                      : "block mb-2 text-lg font-medium text-white"
                  }
                >
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  class="bg-gray-50 border border-gray-300 text-gray-900 h-28 w-full text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Enter your message"
                  required
                />
              </div>
              <div className="flex justify-between">
                <div className="underline">
                  <a href="mailto:manojgum@gmail.com">Send me email directly</a>
                </div>
                <button className="bg-indigo-500 text-white px-4 py-2 w-40 rounded-md hover:bg-indigo-400">
                  Send
                </button>
              </div>
            </form>
          </div>
          <div className="w-full flex flex-col md:items-left  mt-12 md:mt-6 margin-top:30px">
            <div>
              <h1 className="text-1xl font-bold ">Email :-</h1>
              <a
                href="mailto:manojgum@gmail.com"
                className="mb-12 mt-4 font-semibold text-blue-700"
              >
                Manojgum@gmail.com
              </a>
            </div>
            <div>
              <h1 className="text-1xl font-bold">Contact No :-</h1>
              <a
                href="mailto:7909012986"
                className="mb-12 mt-4 font-semibold text-blue-700"
              >
                +91 7909012986
              </a>
            </div>

            <h1 className="text-1xl  font-bold">Social :-</h1>
            <ul className="flex">
              {contactLinks.map((el) => (
                <div>
                  <a
                    href={el.link}
                    className="md:ml-6 md:mr-0 mr-6 cursor-pointer mt-4 hover:scale-125 flex flex-col justify-center items-center"
                  >
                    <img alt="" src={el.url} style={{width:"50px", height: "50px"}} />
                    <p className="text-md mt-2 hover:hidden">{el.name}</p>
                  </a>
                </div>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div
        className={
          darkMode
            ? "w-full bg-gray-100  text-black py-3 flex justify-center "
            : "w-full bg-gray-700 text-white  py-3 flex justify-center"
        }
      >
        <div></div>
        Copyright © 2024 Manoj Kumar
      </div>
    </div>
  );
};

export default Contact;
